// extracted by mini-css-extract-plugin
export default {"programs":"style_programs__MY2Pn","programsHeader":"style_programsHeader__WTez7","programsCategories":"style_programsCategories__ZXNgp"};